module.exports = __webpack_public_path__ + "static/media/safety-reman-2.e18c8f44.png";